export const NTPE_GETTING_STARTED_LINK = 'https://paetep.freshdesk.com/support/solutions/articles/13000012268-ntpe-observations';
